
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install() {
  }
};

export default GlobalDirectives;
